import { EstateInputDataFormatListOption } from 'queries';

import Modal from 'common/modal';

import EstateInputDataFormatListOptionForm from './estate-input-data-format-list-option-form';

type Props = {
  estateInputDataFormatId: string;
  selectedEstateInputDataFormatListOption: EstateInputDataFormatListOption;
  setSelectedEstateInputDataFormatListOption: (
    value: EstateInputDataFormatListOption | undefined,
  ) => void;
  setShowModal: (value: boolean) => void;
  showModal: boolean;
};

export default function EditEstateInputDataFormatListOptionModal({
  estateInputDataFormatId,
  selectedEstateInputDataFormatListOption,
  setSelectedEstateInputDataFormatListOption,
  setShowModal,
  showModal,
}: Props) {
  const onExitClick = () => {
    setShowModal(false);
    setSelectedEstateInputDataFormatListOption(undefined);
  };

  return (
    <Modal
      setShowModal={setShowModal}
      onExitClick={onExitClick}
      showModal={showModal}
      showActions={false}
      content={
        <EstateInputDataFormatListOptionForm
          estateInputDataFormatId={estateInputDataFormatId}
          isEditing={true}
          selectedEstateInputDataFormatListOption={selectedEstateInputDataFormatListOption}
          onExitClick={onExitClick}
        />
      }
      loading={false}
      actionDisabled={false}
      maxWidth="xl"
    />
  );
}
